export default __webpack_public_path__ + "static/media/Mark-6-Suit-02.33c392a1.jpg";